module.exports = __webpack_public_path__ + "images/ic_search_black_24px.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/ic_search_black_24px.svg
 ** module id = 62
 ** module chunks = 1
 **/